var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#0DA9B9",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62357 11.9997C6.62357 10.5742 7.18974 9.2067 8.1986 8.19856C9.20663 7.1897 10.5742 6.62353 11.9998 6.62353V5.33325C10.2315 5.33325 8.53644 6.03551 7.28552 7.28546C6.03557 8.53625 5.33331 10.2314 5.33331 11.9997L6.62357 11.9997Z",
    fill: "#007FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 17.3757V18.666C13.7681 18.666 15.4631 17.9637 16.7141 16.7137C17.964 15.463 18.6663 13.7678 18.6663 11.9995H17.376C17.376 13.425 16.8098 14.7925 15.801 15.8007C14.7929 16.8095 13.4254 17.3757 11.9998 17.3757L11.9998 17.3757Z",
    fill: "#007FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 8.77417C11.1459 8.77417 10.3252 9.11437 9.72047 9.71919C9.11576 10.324 8.77545 11.1447 8.77545 11.9997H10.0657C10.0657 10.9312 10.9326 10.0643 12.0011 10.0643L12.001 8.77417Z",
    fill: "#007FA1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2255 12H13.9352C13.9352 13.0685 13.0683 13.9354 11.9998 13.9354V15.2257C12.855 15.2257 13.6757 14.8855 14.2804 14.2807C14.8851 13.6759 15.2254 12.8552 15.2254 12.0001L15.2255 12Z",
    fill: "#007FA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.6516cc4ce2050f065b2808769a0c60df.svg";
export { ForwardRef as ReactComponent };